import { defineAction } from '~/prix'
import { z } from 'zod'
import creditProgramUpdateAction from './creditProgramUpdate.action.json' with { type: 'json' }
import { creditProgramUpdateInputObject } from '../creditProgramObject'

const creditProgramUpdateDefinition = defineAction({
  ...creditProgramUpdateAction,

  input: creditProgramUpdateInputObject,
  output: z.object({}),
})

export default creditProgramUpdateDefinition

